import { TextField } from '@mui/material'

const TextInput = TextField

export { TextInput }
